import { createEndpointConfig } from '@ricoh/ria.client.core/plugins/swr/common';

import createRequestConfig from '../_config';

/** AntiForgery request config. */
const requestConfig = createRequestConfig('antiForgery', (keyBase) => ({
  getCSRFToken: createEndpointConfig(`[get] ${keyBase}/anti-forgery/get-csrf-token`, () => ({
    method: 'get',
    url: 'anti-forgery/get-csrf-token',
  })),
}));

export default requestConfig;
